<script setup>
import { WParagraph } from '@alice-health/wonderland-vue'
import { computed, onMounted } from 'vue'

const props = defineProps({
  result: {
    type: Object,
    default: () => ({})
  }
})
const emit = defineEmits(['close'])
const message = computed(() => {
  if (props.result.error) {
    return 'Não foi possível realizar o login.\nTente novamente mais tarde.'
  }

  return 'Autenticação realizada com sucesso!'
})
onMounted(() => {
  if (props.result.error) return
  setTimeout(() => emit('close'), 2000)
})
</script>

<template>
  <article>
    <div class="box">
      <WParagraph class="message" size="large">
        {{ message }}
      </WParagraph>
    </div>
  </article>
</template>

<style lang="scss" scoped>
.box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: var(--gl-spacing-04) 0;
}
</style>
